import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [footerSocial, setFooterSocial] = useState([]);
  const [footerCopyright, setFooterCopyright] = useState([]);
  const [logo, setLogo] = useState([]);
  const [footerAddress, setFooterAddress] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false); // State for "Scroll to Top" button visibility

  // Fetch logo data
  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/logo`)
      .then((res) => res.json())
      .then((info) => setLogo(info));
  }, []);

  // Fetch footer address
  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  // Fetch social links
  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  // Fetch copyright
  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/copyrights`)
      .then((res) => res.json())
      .then((info) => setFooterCopyright(info));
  }, []);

  // Handle form submission for subscribers
  const handleSubscriber = (event) => {
    event.preventDefault();
    const subemail = event.target.subemail.value;

    const addItem = { subemail };

    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/add-subscriber`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addItem),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Subscription request sent successfully!");
      });
  };

  // Show "Scroll to Top" button when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (


    <><section className="footer-section">
      <div className="container">
        <div className="middle-portion">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
              <div className="icons">
                {
                  logo.map(l => <a href="/">
                    <figure className="footer-logo">
                      <img src={l.logo} alt />
                    </figure>
                  </a>)}

                {
                  footerSocial.map(f => <ul className="list-unstyled mb-0">
                    <li>
                      <a href={f.fblink}><i className="fa-brands fa-facebook-f" /></a>
                    </li>
                    <li>
                      <a href={f.youlink}><i className="fa-brands fa-youtube" /></a>
                    </li>
                    <li>
                      <a href={f.inslink}><i className="fa-brands fa-instagram" /></a>
                    </li>
                    <p className="paragraph dark">
                      {f.aboutText}
                    </p>
                  </ul>)}
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-12 d-lg-block d-none">
              {/* <div className="services">
                <h3 className="heading">Services</h3>
                <ul className="list-unstyled mb-0">
                  <li><a href="./index.html#statistics" className=" text text-decoration-none">Statistics</a></li>
                  <li><a href="./index.html#basic-feature" className=" text text-decoration-none">Basic Features</a></li>
                  <li><a href="./features.html#about-app" className=" text text-decoration-none">About App</a></li>
                  <li><a href="./pricing.html" className=" text text-decoration-none">Pricing</a></li>
                </ul>
              </div> */}
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-sm-block">
              <div className="links">
                <h3 className="heading">Quick Links</h3>
                <ul className="list-unstyled mb-0">
                  <li><a href="/" className=" text text-decoration-none">Home</a></li>
                  <li><a href="#services-sec" className=" text text-decoration-none">Services</a></li>
                  <li><a href="#pricing-sec" className=" text text-decoration-none">Pricing</a></li>
                  {/* <li><a href="/blog" className=" text text-decoration-none">Blog</a></li> */}
                  <li><a href="#contact-sec" className=" text text-decoration-none">Contact Us</a></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-md-block d-none">
              <div className="aboutus">
                <h3 className="heading">Contact Us</h3>
                <ul className="list-unstyled mb-0">
                  {
                    footerAddress.map(a => <div>
                      <p className="paragraph dark">
                        <i className="fas fa-envelope me-2" /> Email: {a.emailAddress}
                      </p>
                      <p className="paragraph dark">
                        <i className="fas fa-phone-alt  me-2" /> Phone: {a.phoneNumber}
                      </p>
                      <p className="paragraph dark">
                        <i className="fas fa-map-marker-alt  me-2" /> {a.location}
                      </p>
                    </div>)
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-lower">
          <div className="row">
            {
              footerCopyright.map(f => <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <p className="mb-0 text-size-18 text-center">©{f.copyrightText}</p>
              </div>)}

          </div>
        </div>
        {/* Scroll to Top Button */}
        {isScrollVisible && (
          <button
            className="btn position-fixed bottom-0 end-0 m-3"
            onClick={scrollToTop}
            style={{
              zIndex: 1000,
              backgroundColor: '#FE7B53',  // Red color for the button
              borderRadius: '50%',         // Make the button fully round
              padding: '20px',              // Adjust padding for appropriate size
              color: 'white',              // White text color for contrast
              border: 'none',              // Remove border
              fontSize: '15px',            // Make text size appropriate and readable
              fontWeight: 'bold',          // Bold text for better visibility
              boxShadow: '0 4px 6px hsla(0, 0.00%, 0.00%, 0.10)',  // Add subtle shadow for modern look
              cursor: 'pointer',          // Pointer cursor to indicate it's clickable
              transition: 'all 0.3s ease', // Smooth transition on hover
              width: '60px',              // Ensure the button has a fixed width
              height: '60px',             // Ensure the button has a fixed height (making it a perfect circle)
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'scale(1.1)'; // Button scale on hover
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'scale(1)';   // Revert button scale when hover ends
            }}
          >
            ↑
          </button>
        )}
      </div>
    </section>
    </>
  );
};

export default Footer;
